/* eslint-disable camelcase */
/**
 * Created by spy on 2018/4/28.
 */

// g_baseURL = window.location.origin; //打包接口公共部分
// g_baseURL = "http://intest.el.net"; //打包接口公共部分

exports.install = function (Vue) {
  Vue.prototype.checkTime = function (i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  };
  // 判断单点登录
  Vue.prototype.isSingleLogin = function () {
    let id = localStorage._user_data_id;
    // console.log('isSingleLogin',localStorage[`_from_api_${id}`], localStorage[`_from_share_${id}`])
    if (
      localStorage.getItem(`_from_api_${id}`) == 1 ||
      (localStorage.getItem(`_from_share_${id}`) == 1 &&
        localStorage.getItem(`company_category`) == 5)
    ) {
      return true;
    } else {
      return false;
    }
    // if(localStorage._user_data_id && localStorage._source_type) {
    //   return true
    // } else {
    //   return false
    //   }
  };
  // 判断是否要请求权限接口
  Vue.prototype.needGetPermission = function () {
    let id = localStorage._user_data_id;
    if (
      localStorage.getItem(`_from_api_${id}`) == 1 ||
      localStorage.getItem(`_from_share_${id}`) == 1
    ) {
      return true;
    } else {
      return false;
    }
  };
  // 获取url中参数
  Vue.prototype.getQueryString = function (name) {
    var after = window.location.hash.split("?")[1];
    if (after) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = after.match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      } else {
        return null;
      }
    }
  };
  // 是否空backurl
  Vue.prototype.emptyBackUrl = function () {
    if (
      window.location.hash.indexOf("back_url") > -1 &&
      this.getQueryString("back_url") == ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  // 隐私政策
  Vue.prototype.privacyAgreeCheck = function (params) {
    let g_baseURL =
      process.env.VUE_APP_MODE === "local"
        ? `${window.location.origin}/api`
        : window.location.origin;
    window.privacyAgreeCheck && window.privacyAgreeCheck(params, g_baseURL);
  };
};
